// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "de",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_339924ca",
      load: () => import("#nuxt-i18n/339924ca" /* webpackChunkName: "locale_en_46json_339924ca" */),
      cache: true
    },
    {
      key: "locale_en_46json_457b5d12",
      load: () => import("#nuxt-i18n/457b5d12" /* webpackChunkName: "locale_en_46json_457b5d12" */),
      cache: true
    },
    {
      key: "locale_en_46json_b7a6725b",
      load: () => import("#nuxt-i18n/b7a6725b" /* webpackChunkName: "locale_en_46json_b7a6725b" */),
      cache: true
    },
    {
      key: "locale_en_46json_2d7f2c26",
      load: () => import("#nuxt-i18n/2d7f2c26" /* webpackChunkName: "locale_en_46json_2d7f2c26" */),
      cache: true
    },
    {
      key: "locale_en_46json_0f89c35a",
      load: () => import("#nuxt-i18n/0f89c35a" /* webpackChunkName: "locale_en_46json_0f89c35a" */),
      cache: true
    },
    {
      key: "locale_en_46json_509aac86",
      load: () => import("#nuxt-i18n/509aac86" /* webpackChunkName: "locale_en_46json_509aac86" */),
      cache: true
    },
    {
      key: "locale_en_46json_2842bad5",
      load: () => import("#nuxt-i18n/2842bad5" /* webpackChunkName: "locale_en_46json_2842bad5" */),
      cache: true
    },
    {
      key: "locale_en_46json_50a14a69",
      load: () => import("#nuxt-i18n/50a14a69" /* webpackChunkName: "locale_en_46json_50a14a69" */),
      cache: true
    },
    {
      key: "locale_en_46json_2c89b3ff",
      load: () => import("#nuxt-i18n/2c89b3ff" /* webpackChunkName: "locale_en_46json_2c89b3ff" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_65cc31cb",
      load: () => import("#nuxt-i18n/65cc31cb" /* webpackChunkName: "locale_fr_46json_65cc31cb" */),
      cache: true
    },
    {
      key: "locale_fr_46json_ea1e73d7",
      load: () => import("#nuxt-i18n/ea1e73d7" /* webpackChunkName: "locale_fr_46json_ea1e73d7" */),
      cache: true
    },
    {
      key: "locale_fr_46json_05e380d1",
      load: () => import("#nuxt-i18n/05e380d1" /* webpackChunkName: "locale_fr_46json_05e380d1" */),
      cache: true
    },
    {
      key: "locale_fr_46json_ef82c5df",
      load: () => import("#nuxt-i18n/ef82c5df" /* webpackChunkName: "locale_fr_46json_ef82c5df" */),
      cache: true
    },
    {
      key: "locale_fr_46json_eb4f112c",
      load: () => import("#nuxt-i18n/eb4f112c" /* webpackChunkName: "locale_fr_46json_eb4f112c" */),
      cache: true
    },
    {
      key: "locale_fr_46json_f76accbe",
      load: () => import("#nuxt-i18n/f76accbe" /* webpackChunkName: "locale_fr_46json_f76accbe" */),
      cache: true
    },
    {
      key: "locale_fr_46json_7b06716d",
      load: () => import("#nuxt-i18n/7b06716d" /* webpackChunkName: "locale_fr_46json_7b06716d" */),
      cache: true
    },
    {
      key: "locale_fr_46json_c0ed8b12",
      load: () => import("#nuxt-i18n/c0ed8b12" /* webpackChunkName: "locale_fr_46json_c0ed8b12" */),
      cache: true
    },
    {
      key: "locale_fr_46json_209ea2a0",
      load: () => import("#nuxt-i18n/209ea2a0" /* webpackChunkName: "locale_fr_46json_209ea2a0" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_d4501580",
      load: () => import("#nuxt-i18n/d4501580" /* webpackChunkName: "locale_de_46json_d4501580" */),
      cache: true
    },
    {
      key: "locale_de_46json_e73683dd",
      load: () => import("#nuxt-i18n/e73683dd" /* webpackChunkName: "locale_de_46json_e73683dd" */),
      cache: true
    },
    {
      key: "locale_de_46json_708007d2",
      load: () => import("#nuxt-i18n/708007d2" /* webpackChunkName: "locale_de_46json_708007d2" */),
      cache: true
    },
    {
      key: "locale_de_46json_5179cdcd",
      load: () => import("#nuxt-i18n/5179cdcd" /* webpackChunkName: "locale_de_46json_5179cdcd" */),
      cache: true
    },
    {
      key: "locale_de_46json_e3a7ba04",
      load: () => import("#nuxt-i18n/e3a7ba04" /* webpackChunkName: "locale_de_46json_e3a7ba04" */),
      cache: true
    },
    {
      key: "locale_de_46json_17e43d3e",
      load: () => import("#nuxt-i18n/17e43d3e" /* webpackChunkName: "locale_de_46json_17e43d3e" */),
      cache: true
    },
    {
      key: "locale_de_46json_3b69aa1b",
      load: () => import("#nuxt-i18n/3b69aa1b" /* webpackChunkName: "locale_de_46json_3b69aa1b" */),
      cache: true
    },
    {
      key: "locale_de_46json_3e18811b",
      load: () => import("#nuxt-i18n/3e18811b" /* webpackChunkName: "locale_de_46json_3e18811b" */),
      cache: true
    },
    {
      key: "locale_de_46json_3bd1f143",
      load: () => import("#nuxt-i18n/3bd1f143" /* webpackChunkName: "locale_de_46json_3bd1f143" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_14d5b677",
      load: () => import("#nuxt-i18n/14d5b677" /* webpackChunkName: "locale_es_46json_14d5b677" */),
      cache: true
    },
    {
      key: "locale_es_46json_4ac4939e",
      load: () => import("#nuxt-i18n/4ac4939e" /* webpackChunkName: "locale_es_46json_4ac4939e" */),
      cache: true
    },
    {
      key: "locale_es_46json_41a5aa42",
      load: () => import("#nuxt-i18n/41a5aa42" /* webpackChunkName: "locale_es_46json_41a5aa42" */),
      cache: true
    },
    {
      key: "locale_es_46json_5be06087",
      load: () => import("#nuxt-i18n/5be06087" /* webpackChunkName: "locale_es_46json_5be06087" */),
      cache: true
    },
    {
      key: "locale_es_46json_24cfc1b0",
      load: () => import("#nuxt-i18n/24cfc1b0" /* webpackChunkName: "locale_es_46json_24cfc1b0" */),
      cache: true
    },
    {
      key: "locale_es_46json_2028a926",
      load: () => import("#nuxt-i18n/2028a926" /* webpackChunkName: "locale_es_46json_2028a926" */),
      cache: true
    },
    {
      key: "locale_es_46json_2b7ec610",
      load: () => import("#nuxt-i18n/2b7ec610" /* webpackChunkName: "locale_es_46json_2b7ec610" */),
      cache: true
    },
    {
      key: "locale_es_46json_edca285f",
      load: () => import("#nuxt-i18n/edca285f" /* webpackChunkName: "locale_es_46json_edca285f" */),
      cache: true
    },
    {
      key: "locale_es_46json_5a043d44",
      load: () => import("#nuxt-i18n/5a043d44" /* webpackChunkName: "locale_es_46json_5a043d44" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  }
]

